export default function postVSTOEvent(message) {
  try {
    window.chrome.webview.postMessage(message);
  } catch (err) {
    //not VSTO
  }
}
